import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.server.auth.update;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'SERVER_AUTH_UPDATE',
	method: 'POST',
	url: '/server/auth/update.json',
});

export { actions, reducer, sagas, selectors };
